import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorOrderPurchaseTable from './components/VendorOrderPurchaseTable';

const VendorOrderPurchase = () => {
  return (
    <ErrorBoundary>
      <VendorOrderPurchaseTable />
    </ErrorBoundary>
  );
};

export default VendorOrderPurchase;
